import React, { useEffect } from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { useDispatch } from "react-redux";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { ApplicationBar } from "../features/appbar/ApplicationBar";
import { ChurchBar } from "../features/church/ChurchBar";
import { setChurch } from "../features/church/churchSlice";
import { Toolbar } from "../features/toolbar/Toolbar";
import { LinkList } from "../features/links/LinkList";
import { Details } from "../features/details/Details";

const queryClient = new QueryClient();

const theme = createTheme({
  palette: {
    primary: {
      main: "#025D8F"
    }
  }
});

function LinkListPage() {
  const dispatch = useDispatch();

  useEffect(() => {
    // Tyhjennä rauhanyhdistyksen tiedot kun palataan LinkListPage-sivulle
    dispatch(setChurch(null));
  }, [dispatch]);

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            minHeight: "100vh"
          }}
        >
          <ApplicationBar />
          <ChurchBar />
          <Toolbar hideDaySelector={true}/>

          
          <LinkList />
          <Details />
        </Box>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default LinkListPage;
